// Replaces all \n with <br>
export function addParagraphs(notes: any): string {
    if (typeof notes !== 'string') {
        console.error("The input is not a string:", notes);
        return '';
    }

    return notes.replace(/\\n|\r\n|\n/g, "<br />");
}
